import { Button, Result, Tabs } from 'antd'
import { useRef, useState, forwardRef } from 'react'
import BaseInfo from './tabsItem/baseInfo'
import Business from './tabsItem/business'
import Order from './tabsItem/order'
import Collection from './tabsItem/collection'
import Project from './tabsItem/project'
import Clue from './tabsItem/clue'
import { getAuth } from '@/utils/auth'
import { SettingOutlined } from '@ant-design/icons'
import { TabComponentInterface } from '../index.d'
import MeasureRoomLog from "@/pages/customerProfile/components/tabsItem/measureRoomLog";
import CallLog from "@/pages/customerProfile/components/tabsItem/callLog";

const UserInfoTabs = () => {
  const auth = getAuth()
  const [activeKey, setActiveKey] = useState('baseInfo')
  const activeComponentRef = useRef<TabComponentInterface>(null)

  // 提取组件映射关系
  const componentMap = {
    baseInfo: forwardRef<TabComponentInterface>((_, ref) => <BaseInfo ref={ref} />),
    clue: forwardRef<TabComponentInterface>((_, ref) => <Clue ref={ref} />),
    business: forwardRef<TabComponentInterface>((_, ref) => <Business ref={ref} />),
    order: forwardRef<TabComponentInterface>((_, ref) => <Order ref={ref} />),
    collection: forwardRef<TabComponentInterface>((_, ref) => <Collection ref={ref} />),
    project: forwardRef<TabComponentInterface>((_, ref) => <Project ref={ref} />),
    callLog: forwardRef<TabComponentInterface>((_, ref) => <CallLog ref={ref} />),
    measureRoomLog: forwardRef<TabComponentInterface>((_, ref) => <MeasureRoomLog ref={ref} />),
  }

  const openSettingModal = () => {
    activeComponentRef.current?.openSettingModal?.()
  }

  const items = [
    {
      key: 'baseInfo',
      label: '基础信息',
    },
    {
      key: 'callLog',
      label: '呼叫记录',
    },
    {
      key: 'clue',
      label: '线索',
    },
    {
      key: 'business',
      label: '商机',
    },
    {
      key: 'measureRoomLog',
      label: '量房记录',
    },
    {
      key: 'order',
      label: '订单',
    },
    {
      key: 'collection',
      label: '收款服务',
    },
    {
      key: 'project',
      label: '工程管理',
    },
  ]

  const itemsByAuth = items.filter(item => auth[`${item.key}Tab`])

  const onChange = (key: string) => {
    setActiveKey(key)
  }

  // 动态渲染当前激活的组件
  const ActiveComponent = componentMap[activeKey as keyof typeof componentMap]

  return (
    <div
      style={{
        marginTop: 10,
        backgroundColor: '#fff',
        padding: '8px 20px',
        height: 'calc(100vh - 300px)',
        overflow: 'auto',
        width: '65vw',
      }}
    >
      {itemsByAuth.length > 0 ? (
        <>
          <Tabs
            defaultActiveKey="baseInfo"
            items={itemsByAuth}
            onChange={onChange}
            tabBarExtraContent={{
              right:
                activeKey !== 'baseInfo' ? (
                  <Button type="link" icon={<SettingOutlined />} onClick={openSettingModal} />
                ) : null,
            }}
          />
          <ActiveComponent ref={activeComponentRef} />
        </>
      ) : (
        <Result status="403" title="403" subTitle="暂无权限" />
      )}
    </div>
  )
}

export default UserInfoTabs
